import { createContext, type ReactNode } from 'react'

import type { Combobox } from '@base-ui/react/combobox'
import type { ValueSelectorButtonProps } from './types'

export const ValueSelectPresentationContext = createContext<{
    open: boolean
    onOpenChange: (open: boolean, eventDetails?: Combobox.Root.ChangeEventDetails) => void
    children: ReactNode
    buttonProps: ValueSelectorButtonProps
} | null>(null)
